import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon } from './icon-utils';

export function PlaceholderIcon({
  className,
  fill = '#3C44A2',
  height,
  width,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      height={height ?? 16}
      viewBoxDimensions="0 0 16 16"
      width={width ?? 16}
    >
      <path
        d="M7.5 7.9a0.30625 0.30625 0 0 0 -0.11875 -0.24375000000000002 4.64375 4.64375 0 0 0 -2.875 -1.0187499999999998A4.725 4.725 0 0 0 0 10a0.30625 0.30625 0 0 0 0.05 0.275 0.3 0.3 0 0 0 0.25 0.125h6.875a0.3125 0.3125 0 0 0 0.3125 -0.3125Z"
        fill={fill}
        strokeWidth="1"
      />
      <path
        d="M1.40625 3.05a2.96875 2.96875 0 1 0 5.9375 0 2.96875 2.96875 0 1 0 -5.9375 0"
        fill={fill}
        strokeWidth="1"
      />
      <path
        d="M10.78125 11.950000000000001h-0.46875a0.3125 0.3125 0 0 1 -0.3125 -0.3125v-3.125a0.78125 0.78125 0 0 0 -1.5625 0v3.125a0.3125 0.3125 0 0 1 -0.3125 0.3125h-0.46875a0.31875 0.31875 0 0 0 -0.25625 0.5l1.5625 2.1875a0.325 0.325 0 0 0 0.5125 0l1.5625 -2.1875a0.31875 0.31875 0 0 0 -0.25625 -0.5Z"
        fill={fill}
        strokeWidth="1"
      />
      <path
        d="m14.94375 10.206249999999999 -1.5625 -2.1875a0.33125000000000004 0.33125000000000004 0 0 0 -0.5125 0l-1.5625 2.1875a0.30625 0.30625 0 0 0 0 0.325 0.3 0.3 0 0 0 0.275 0.16875h0.46875a0.3125 0.3125 0 0 1 0.3125 0.3125v3.125a0.78125 0.78125 0 1 0 1.5625 0v-3.125a0.3125 0.3125 0 0 1 0.3125 -0.3125h0.46875a0.3 0.3 0 0 0 0.275 -0.16875 0.30625 0.30625 0 0 0 -0.0375 -0.325Z"
        fill={fill}
        strokeWidth="1"
      />
    </SimpleIcon>
  );
}
